import { html, CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './tufts-rating.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';

@customElement('tufts-rating')
export class TuftsRating extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: Number }) score = 0;
  @property({ type: String }) variant: string;
  @property({ type: String }) date: string;

  render() {
    return html`
      <div class="container ${this.variant}">
        <div class="rating-score">${this.score.toFixed(1)}</div>
        <div class="rating-container">
          <div
            class="average-rating"
            style="--percent-rating: calc(${this.score}/5*100%);"
          >
            <span class="visually-hidden"
              >Average score:${this.score} out of 5</span
            >
          </div>
          ${this.variant && this.date
            ? html` <span class="rating-date"> ${this.date}</span>`
            : null}
        </div>
        <slot></slot>
      </div>
    `;
  }
}
